module.exports = "https://www.gc-qa.gnp.com.mx/da008406ef7aab9809809d9b6462e35b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons-gnp/logo-GNP.svg
// module id = 1846
// module chunks = 0